'use client';

import {useLocalization} from '@/hooks/useLocalization';
import {useTranslations} from 'next-intl';
import {useMemo} from 'react';
import {Discount as IconDiscount} from '../../../../../components/icons';
import {Link} from '@/i18n/routing';
import ProductList from '../commons/ProductList';
import useFindDiscountedProductsQuery from '../query/useFindDiscountedProductsQuery';
import useFilters from './hooks/useFilters';

export default function DiscountedProducts() {
  const t = useTranslations('shop');

  const {hasActiveFilters} = useFilters();

  const {hash, deliveryType} = useLocalization();
  const {data, isLoading} = useFindDiscountedProductsQuery({
    hash: hash || '',
    deliveryType,
    enabled: !hasActiveFilters,
  });

  const products = useMemo(() => {
    return data?.items || [];
  }, [data]);

  if (hasActiveFilters || !data || data.items.length === 0) {
    return null;
  }

  return (
    <div className="sm:space-y-6">
      <div className="flex sm:items-center justify-between gap-1">
        <h2 className="flex items-center gap-2 text-3xl text-greyscale-title font-bold tracking-tighter leading-8 m-0 p-0">
          <IconDiscount className="text-primary hidden sm:block" />
          {t('main.discountedTitle')}
        </h2>
        <Link
          href={{
            pathname: '/shop',
            query: {tag: 'angoloccasioni'},
          }}
          className="text-greyscale-body underline text-base font-medium tracking-tight cursor-pointer whitespace-nowrap"
        >
          {t('filter.more')}
        </Link>
      </div>
      <ProductList
        columns={{
          xl: 4,
          lg: 3,
          md: 2,
          sm: 2,
          xs: 1,
        }}
        loading={isLoading}
        products={products}
      />
    </div>
  );
}
